// 创建文件en.js
const en = {
  test: 'hello',
  language: {
    privacy: "Privacy Policy",
    service: "Service Terms",
    home: "HOME"
  },
}
export default en;



// WEBPACK FOOTER //
// ./src/lang/en.js